import { CustomFieldDivider } from '../../types'
import { fetchCustomFieldDividers } from '../../services/custom-field-dividers.service'
import { actions as customActions } from './custom-field-dividers.actions'
import { getters as customGetters } from './custom-field-dividers.getters'
import { state as customState } from './custom-field-dividers.state'
import { mutations as customMutations } from './custom-field-dividers.mutations'
import createBaseStore from '../createStoreHelper'

export const CustomFieldDividersModule: any = createBaseStore<CustomFieldDivider>({
  resourceName: 'dividers',
  plural: 'dividers',
  apiCalls: {
    fetchAllApiCall: fetchCustomFieldDividers
  }
})

CustomFieldDividersModule.actions = { ...CustomFieldDividersModule.actions, ...customActions }
CustomFieldDividersModule.getters = { ...CustomFieldDividersModule.getters, ...customGetters }
CustomFieldDividersModule.state = { ...CustomFieldDividersModule.state, ...customState }
CustomFieldDividersModule.mutations = { ...CustomFieldDividersModule.mutations, ...customMutations }
